var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBusinessStarter = function SvgBusinessStarter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M32 36c-7.85 0-14-6.15-14-14S24.28 8 32 8s14 6.28 14 14-6.15 14-14 14Zm0-26c-6.62 0-12 5.38-12 12s5.27 12 12 12 12-5.27 12-12-5.38-12-12-12ZM54 56a.99.99 0 0 1-.93-.64C48.74 44.23 41.8 42 32 42s-16.73 2.24-21.07 13.36c-.2.51-.78.77-1.29.57-.51-.2-.77-.78-.57-1.29C13.8 42.49 21.66 40 32 40s18.2 2.49 22.93 14.64c.2.51-.05 1.09-.57 1.29-.12.05-.24.07-.36.07Z"
  })));
};
export default SvgBusinessStarter;